import './PetType.scss';
import { useEffect, useState } from 'react';
import { ReactComponent as PetCat } from '@/assets/img/pet-type-cat.svg';
import { ReactComponent as PetDog } from '@/assets/img/pet-type-dog.svg';
import { useTranslation } from 'react-i18next';

type PetTypeProps = {
  onChange?: (type: string) => void;
  value?: string;
  readOnly?: boolean;
  defaultPetType?: string;
};
export const PetType = ({ onChange, value, readOnly, defaultPetType }: PetTypeProps) => {
  const [petType, setPetType] = useState<string>();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (defaultPetType) {
      onChange && onChange(defaultPetType);
      setPetType(defaultPetType);
    }
  }, []);
  useEffect(() => {
    petType && onChange && onChange(petType);
  }, [petType]);

  useEffect(() => {
    setPetType(value);
  }, [value]);

  return (
    <div className={`pet-type-container ${readOnly ? 'read' : ''}`}>
      {(!defaultPetType || defaultPetType.toLowerCase() === 'dog') && (
        <div
          className={`pet-type dog ${
            petType ? (petType?.toLowerCase() === 'dog' ? 'selected' : '') : 'empty'
          }`}
          onClick={() => !readOnly && setPetType('dog')}
        >
          <PetDog className="dog" />
          <div className="">
            <div className="title">{t('Dog')}</div>
            {/* <div>{userContext?.isLandscape ? 'I have a ' : ''} pet doggie</div> */}
          </div>
        </div>
      )}
      {(!defaultPetType || defaultPetType.toLowerCase() === 'cat') && (
        <div
          className={`pet-type cat ${
            petType ? (petType?.toLowerCase() === 'cat' ? 'selected' : '') : 'empty'
          }`}
          onClick={() => !readOnly && setPetType('cat')}
        >
          <PetCat className="cat" />
          <div className="">
            <div className="title">{t('Cat')}</div>
            {/* <div className="desc">{userContext?.isLandscape ? 'I have a ' : ''} cute kittie</div> */}
          </div>
        </div>
      )}
    </div>
  );
};
